import styled from "@emotion/styled";
import { colors } from "goi_common";

interface NormalTableProps {
  head: string[];
  body: string[][];
}

function Table({ head, body }: NormalTableProps) {
  const column = head.length;

  return (
    <TableRoot column={column}>
      <thead>
        <tr>
          {head.map((h, index) => (
            <th key={h + index} className="body3_r" dangerouslySetInnerHTML={{ __html: h }} />
          ))}
        </tr>
      </thead>
      <tbody>
        {body.map((row) => (
          <tr key={row.toString()}>
            {row.map((d, index) => (
              <td key={d + index} className="body3_r" dangerouslySetInnerHTML={{ __html: d }} />
            ))}
          </tr>
        ))}
      </tbody>
    </TableRoot>
  );
}

const TableRoot = styled.table<{ column: number }>`
  width: 100%;
  border-collapse: collapse;

  th,
  tr > td:first-of-type,
  .t-header {
    font-weight: bold;
    background: ${colors.gray50};
  }

  th,
  td {
    min-width: 100px;
    width: calc(100% / ${({ column }) => column});
    border: 1px solid var(--gray300);
    padding: 7px;
    text-align: center;
    vertical-align: middle;
  }
`;

export default Table;
